

import { FacebookCampaignsList } from '@/components/settings/FacebookCampaignsList';
import { MetaAppsTab } from '@/components/settings/MetaAppsTab';
import { WhatsAppTemplatesList } from '@/components/settings/WhatsAppTemplatesList';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { META_INTEGRATION_ENABLED } from '@/config/env';
import { useTranslations } from '@/hooks/use-translations';

export function MetaIntegrationPage() {
    const { t } = useTranslations();
    return (
        <div className="container mx-auto py-6 space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-3xl font-bold tracking-tight">Meta Integration</h1>
            </div>

            {!META_INTEGRATION_ENABLED && (
                <div className="rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                    Meta integration is disabled in this environment. Controls are shown for QA reference only.
                </div>
            )}

            <Tabs defaultValue="campaigns" className={`w-full ${!META_INTEGRATION_ENABLED ? 'opacity-60 pointer-events-none' : ''}`}>
                <TabsList>
                    <TabsTrigger value="campaigns">Facebook Campaigns</TabsTrigger>
                    <TabsTrigger value="templates">WhatsApp Templates</TabsTrigger>
                    <TabsTrigger value="apps">{t('meta_apps.tab')}</TabsTrigger>
                </TabsList>

                <TabsContent value="campaigns" className="mt-6">
                    <FacebookCampaignsList />
                </TabsContent>

                <TabsContent value="templates" className="mt-6">
                    <WhatsAppTemplatesList />
                </TabsContent>

                <TabsContent value="apps" className="mt-6">
                    <MetaAppsTab />
                </TabsContent>
            </Tabs>
        </div>
    );
}
